import declare from "dojo/_base/declare";
import locale from "csi/locale";
import MarkForDeletionUOMCustomAttribute from "./MarkForDeletionUOMCustomAttribute";

const UnmarkForDeletionUOMCustomAttribute = declare(MarkForDeletionUOMCustomAttribute, {
	
	bMarkForDeletion: false,

	/**
     * @override
     * Add confirmation message to unmark both attributes for deletion
     */
	confirmAction(params): void {
		if (!this.bMarkForDeletion) {
			params.message = locale.resource("UnmarkForDeletionUOMCustomAttribute_ConfirmationDialog", [this._uomValueAttr.$Name, this._uomConversionAttr.$Name]);
		}
		this.inherited(arguments);
	},
});

export = UnmarkForDeletionUOMCustomAttribute;
